/**
 * The VoiceProp logo in the ModelProp product family style (17 Oct 2026): the house in
 * VoiceProp's gold, "Voice" in gold (darker on white) and "Prop" in indigo,
 * or white on dark. Every Prop product shares this lockup and differs only in colour.
 */
export function Lockup({ onDark = false, size = 'md' }: { onDark?: boolean; size?: 'md' | 'lg' }) {
  return (
    <span
      className={`vp-lockup vp-lockup--${size}${onDark ? ' vp-lockup--dark' : ''}`}
      role="img"
      aria-label="VoiceProp"
    >
      <span className="vp-lockup__mark" aria-hidden="true" />
      <span className="vp-lockup__word" aria-hidden="true">
        <b>Voice</b>Prop
      </span>
    </span>
  );
}

/** ModelProp's own logo with its strapline, for the bottom of the rail and the sign-in screen. */
export function ModelPropSignoff({ onDark = false }: { onDark?: boolean }) {
  return (
    <a
      className={`mp-signoff${onDark ? ' mp-signoff--dark' : ''}`}
      href="https://www.modelprop.ai"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="ModelProp, Trusted Property AI"
    >
      <span className="mp-signoff__logo">
        <span className="mp-signoff__mark" aria-hidden="true" />
        <span className="mp-signoff__word">ModelProp</span>
      </span>
      <span className="mp-signoff__strap">Trusted Property AI</span>
    </a>
  );
}
